module.exports = "../images/homepage/runner.png";